
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mm_sem",
      function () {
        return require("private-next-pages/mm_sem/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mm_sem"])
      });
    }
  